import React, { Component } from 'react';
import { Container, CardBody, Col } from 'reactstrap';
import Holter from '../ClinicHistoryView/components/MedicalProcedures/Holter/Holter';
import Map from '../ClinicHistoryView/components/MedicalProcedures/Map/Map';
import ECO from '../ClinicHistoryView/components/MedicalProcedures/ECO/ECO';
import EKG from '../ClinicHistoryView/components/MedicalProcedures/EKG/EKG';
import Test from '../ClinicHistoryView/components/MedicalProcedures/Test/Test';
import Stress from '../ClinicHistoryView/components/MedicalProcedures/Stress/Stress';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import Spinner from 'react-bootstrap/Spinner';
import history from '../../../history';


class ProceduresView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoding: true,
      servicios: [],
      professional: [],
      data: [],
      MedicalProcedures: {
        ECO: {
          vid: "",
          rao: "",
          e: "",
          pp: "",
          ao: "",
          a: "",
          ps: "",
          vd: "",
          tapse: "",
          vis: "",
          ai: "",
          ad: "",
          fe: "",
          adult: {},
          description: "",
          conclusions: "",
          professional: "",
          medicalOrders: [],
          medicament: {},
          addedMedicaments: [],
          observations: [],
          cie: {
            code: "",
            name: ""
          }
        },
        Stress: {
          vid: "",
          rao: "",
          e: "",
          pp: "",
          ao: "",
          a: "",
          ps: "",
          vd: "",
          tapse: "",
          vis: "",
          ai: "",
          ad: "",
          fe: "",
          adult: {},
          description: "",
          conclusions: "",
          professional: "",
          medicalOrders: [],
          medicament: {},
          addedMedicaments: [],
          observations: [],
          cie: {
            code: "",
            name: ""
          }
        },
        Test: {
          professional: "",
          conclusion: "",
          conclusions: "",
          medicament: {},
          addedMedicaments: [],
          cie: {
            code: "",
            name: ""
          }
        },
        Holter: {
          professional: "",
          conclusion: "",
          medicament: {},
          addedMedicaments: [],
          cie: {
            code: "",
            name: ""
          }
        },
        Map: {
          professional: "",
          conclusion: "",
          medicament: {},
          addedMedicaments: [],
          cie: {
            code: "",
            name: ""
          }
        },
        EKG: {
          ritmo: "",
          fc: "",
          ondaP: "",
          pr: "",
          qrs: "",
          ejeQRS: "",
          styt: "",
          qtc: "",
          professional: "",
          conclusions: "",
          medicament: {},
          addedMedicaments: [],
          file: null,
          cie: {
            code: "",
            name: ""
          }
        }
      },
    }
  }

  componentDidMount() {
    console.log(this.props.location.state.data);
    this.getAdmision();
  }


  getAdmision = () => {
    var data = {
      id_admision: parseInt(this.props.location.state.data.id_admision),
      id_historia: parseInt(this.props.location.state.data.id_historia),
      num_documento: this.props.location.state.data.num_documento,
      fecha: this.props.location.state.data.fecha
    };
    console.log(data);
    fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        this.setState({
          servicios: data.contenido[0].servicio.servicios, data: {
            id_admision: parseInt(this.props.location.state.data.id_admision),
            id_historia: parseInt(this.props.location.state.data.id_historia)
          }
        });
        console.log(this.state.servicios);
        this.getProfessional();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

  }

  getProfessional = () => {

    const dataSend = { id_historia: parseInt(this.props.location.state.data.id_historia), id_admision: parseInt(this.props.location.state.data.id_admision) }
    console.log(dataSend);

    fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataSend)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        this.setState({ professional: data.contenido.profesional });
        if (typeof this.state.servicios === 'undefined') {
          alert("no se registro el procedimiento de esta cita");
          history.push({
            pathname:process.env.PUBLIC_URL + '/search-clinic-history',
          });

        } else {
          console.log(this.state.professional);
          this.setState({ isLoding: false });
        }
      })
      .catch((error) => {
        alert(error);
        console.error('Error:', error);
      });
  }

  handlerMedicalProcedures = (section, variable, value) => {
    this.setState({ MedicalProcedures: { ...this.state.MedicalProcedures, [section]: { ...this.state.MedicalProcedures[section], [variable]: value } } });
  }

  handlerMedications = (section, variable, value) => {
    this.setState({ MedicalProcedures: { ...this.state.MedicalProcedures, [section]: { ...this.state.MedicalProcedures[section], cie: { ...this.state.MedicalProcedures[section].cie, [variable]: value } } } });
  }
  searchMedications = (section, name, code) => {
    console.log(this.state.MedicalProcedures[section]);
    var data = {
      codigo: code, //this.state.MedicalProcedures[section].cie.code,
      nombre: name //this.state.MedicalProcedures[section].cie.name
    };
    console.log(data);
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'medidci/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          if (data.existe) {
            resolve(data.contenido);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          resolve(error);
        });
    })
  }

  selectMedicament = (section, medicament) => {
    this.setState({ MedicalProcedures: { ...this.state.MedicalProcedures, [section]: { ...this.state.MedicalProcedures[section], medicament: medicament } } });
  }

  addMedicament = (section, medicament) => {
    this.setState({ MedicalProcedures: { ...this.state.MedicalProcedures, [section]: { ...this.state.MedicalProcedures[section], addedMedicaments: [...this.state.MedicalProcedures[section].addedMedicaments, medicament] } } });
  }


  removeMedicament = (section, index) => {
    var addedMedicaments = this.state.MedicalProcedures[section].addedMedicaments;
    addedMedicaments = addedMedicaments.filter((value, indexDiag) => {
      return indexDiag !== index;
    });
    this.setState({ MedicalProcedures: { ...this.state.MedicalProcedures, [section]: { ...this.state.MedicalProcedures[section], addedMedicaments: addedMedicaments } } });
  }

  selectMedicament = (section, medicament) => {
    this.setState({ MedicalProcedures: { ...this.state.MedicalProcedures, [section]: { ...this.state.MedicalProcedures[section], medicament: medicament } } });
  }

  render() {

    return (
      <Container className="dashboard">
        <CardBody>
          <div className="tabs tabs--bordered-top">
            <div className="tabs__wrap">
              <Col md={12}>
                <h3 style={{ marginBottom: 30 }}>Procedimiento</h3>
              </Col>
              {this.state.isLoding ? (
                <Spinner animation="border" variant="success" />
              ) : (
                this.state.servicios.formato === "1" ?
                  <ECO cie={this.state.MedicalProcedures.Holter.cie}
                    addedMedicaments={this.state.MedicalProcedures.ECO.addedMedicaments}
                    professional={this.state.professional}
                    medicament={this.state.MedicalProcedures.Holter.medicament}
                    handlerMedicalProcedures={this.handlerMedicalProcedures}
                    handlerMedications={this.handlerMedications}
                    selectMedicament={this.selectMedicament}
                    addMedicament={this.addMedicament}
                    removeMedicament={this.removeMedicament}
                    searchMedications={this.searchMedications} /> :
                  this.state.servicios.formato === "2" ?
                    <Stress cie={this.state.MedicalProcedures.Holter.cie}
                    professional={this.state.professional}
                      medicament={this.state.MedicalProcedures.Holter.medicament}
                      handlerMedicalProcedures={this.handlerMedicalProcedures}
                      handlerMedications={this.handlerMedications}
                      selectMedicament={this.selectMedicament}
                      addMedicament={this.addMedicament}
                      removeMedicament={this.removeMedicament}
                      searchMedications={this.searchMedications} /> :
                    this.state.servicios.formato === "3" ?
                      <Test cie={this.state.MedicalProcedures.Holter.cie}
                      professional={this.state.professional}
                        medicament={this.state.MedicalProcedures.Holter.medicament}
                        handlerMedicalProcedures={this.handlerMedicalProcedures}
                        handlerMedications={this.handlerMedications}
                        selectMedicament={this.selectMedicament}
                        addMedicament={this.addMedicament}
                        removeMedicament={this.removeMedicament}
                        searchMedications={this.searchMedications} /> :
                      this.state.servicios.formato === "4" ?
                        <EKG cie={this.state.MedicalProcedures.Holter.cie}
                        professional={this.state.professional}
                          medicament={this.state.MedicalProcedures.Holter.medicament}
                          handlerMedicalProcedures={this.handlerMedicalProcedures}
                          handlerMedications={this.handlerMedications}
                          selectMedicament={this.selectMedicament}
                          addMedicament={this.addMedicament}
                          removeMedicament={this.removeMedicament}
                          searchMedications={this.searchMedications} /> :
                        this.state.servicios.formato === "5" ?
                          <Holter cie={this.state.MedicalProcedures.Holter.cie}
                            professional={this.state.professional}
                            data={this.state.data}
                            medicament={this.state.MedicalProcedures.Holter.medicament}
                            handlerMedicalProcedures={this.handlerMedicalProcedures}
                            handlerMedications={this.handlerMedications}
                            selectMedicament={this.selectMedicament}
                            addMedicament={this.addMedicament}
                            removeMedicament={this.removeMedicament}
                            searchMedications={this.searchMedications} /> :
                          <Map cie={this.state.MedicalProcedures.Holter.cie}
                          professional={this.state.professional}
                            medicament={this.state.MedicalProcedures.Holter.medicament}
                            handlerMedicalProcedures={this.handlerMedicalProcedures}
                            handlerMedications={this.handlerMedications}
                            selectMedicament={this.selectMedicament}
                            addMedicament={this.addMedicament}
                            removeMedicament={this.removeMedicament}
                            searchMedications={this.searchMedications} />

              )}

            </div>
          </div>
        </CardBody>
      </Container>);

  }
};

export default reduxForm({
  form: `medical-procedures-form`, // a unique identifier for this form
})(withTranslation('common')(ProceduresView));